export function ProjectSelectorPlusMenuItem({ closeMenu, props, }) {
    const insertProject = (project) => {
        const result = props.insertMention(project.mention);
        props.onSelectionResult?.(project, result);
        return result;
    };
    return props.renderProjectSelector({ closeMenu, insertProject });
}
//# sourceMappingURL=ProjectSelectorPlusMenuItem.js.map